import axios from 'axios';

import { extractData, logError } from '@/api/ApiHelpers';

import type { LicenseStatusResponse } from '@/api/ApiTypes';


const licenseStatusGet = (
	handler: (responseData: LicenseStatusResponse) => void,
): void => {
	axios.get('/license/status/').then(extractData(handler)).catch(logError);
};


export default {
	licenseStatusGet,
};
